'use client';

export const AUTH_REQUIRED_EVENT = 'botgo:auth-required';

export function requestClientAuth({ redirectPath = null } = {}) {
  if (typeof window === 'undefined') return false;
  const event = new CustomEvent(AUTH_REQUIRED_EVENT, {
    cancelable: true,
    detail: { redirectPath },
  });
  const handled = !window.dispatchEvent(event);
  if (!handled) {
    const target = new URL(window.location.href);
    target.searchParams.set('auth', 'login');
    if (redirectPath) target.searchParams.set('redirect', redirectPath);
    window.location.assign(target.toString());
  }
  return handled;
}
